// extracted by mini-css-extract-plugin
export default {"UserAccessPage":"CreateAccount_UserAccessPage__twg3q","UserAccessPageCard":"CreateAccount_UserAccessPageCard__T-IzX","Note":"CreateAccount_Note__rA1hI"};